export default [
  {
    path: "/",
    name: "main",
    component: () => import("./pages/index.vue"),
    alias: "/admin",
    meta: {
      authRequired: true,
      layout: "main",
      permissions: ["tank:index", "fuel:index", "application:index", "arrival:index"],
    },
  },
];
